import { lighten } from '@material-ui/core/styles/colorManipulator';
import {colorPrimary} from '../../../utils/setting';

export const styles = theme => ({
    container: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    },
    },
    root: {
        marginTop: theme.spacing(3),
        position: 'relative',
        overflow: 'hidden',
        width: '100%'
        // paddingTop: theme.spacing(2),
        // paddingBottom: theme.spacing(2),
    },
    containerPaper:{
        display: 'flex',
        height: '100%'
    },
    textField: {
        width: '100%'
    },
    input_datepicker: {
        marginTop: '0px',
        marginBottom: '0px',
    },
    wrapSelect:
    {
        display: 'flex',
        paddingBottom: '6px',
        flexDirection: 'column-reverse'
    },
    formControl: {
        boxSizing: 'border-box',
        padding: theme.spacing(2),
        width: '100%'
    }, 
    selected: {
        '&:focus': {
          backgroundColor: 'transparent',
        }
    },
})


export const toolbarStyles = theme => ({
    selectType: {
        textTransform: 'capitalize',
    },
    formControl: {
        // color: theme.palette.text.secondary, 
        color: 'rgb(0, 0, 0)', 
        boxSizing: 'border-box',                                                                                                                                                                                                                                                                                                                                                                                                                                        
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: '#f4f4f4',
        '&:hover': {
            backgroundColor: '#f4f4f4',
        },
        width: '100%',
        display: 'flex',
        height: '2.3rem',
        justifyContent: 'center',
    },
    selected: {
        '&:focus': {
          backgroundColor: 'transparent',
        }
    },
    titleText: {
        fontSize: '1.11rem',
    },
    root: {
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(1),
        boxSizing: 'border-box',
        backgroundColor: 'rgba(41, 47, 72, 0.85)',
        color: '#fff',
        [theme.breakpoints.up('md')]: {
            minHeight: theme.spacing(7)
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: theme.spacing(7)
        },
    },
    label: {
        width: '20%'
    },
    containerInput: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    fixPaddingContainerInput:{
        padding: '18px 12px 0px 12px !important'
    },
    fixMarginInputBase:{
        margin: '0px 0px 0px 16px !important'
    },
    marginSpacing:{
        margin: '-11px !important'
    },
    inputBase: {
        marginLeft: theme.spacing(1),
        color: theme.palette.text.secondary,
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: '#f4f4f4',
        '&:hover': {
            backgroundColor: '#f4f4f4',
        },
        marginLeft: theme.spacing(2),
        marginRight: 0,
        // marginTop: theme.spacing(1),
        marginTop: '6px',
        marginBottom: '6px',
        // marginBottom: theme.spacing(1),
        width: '80%',
    },
    inputRoot: {
        color: 'inherit',
        boxSizing: 'border-box'
    },
    inputRootSelected: {
        minWidth: theme.spacing(14),
    },
    inputInputSelected: {
        boxSizing: 'border-box',
        lineHeight: 'normal'
    },
    inputInput: {
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        transition: theme.transitions.create('width'),
        width: '100%',
    },
    title: {
        flex: '0 0 auto',
        color: '#fff'
    },
});